import type { FC, ReactNode } from 'react'

import Link from 'next/link'

type PagerItem = {
    href: string
    label: string
    meta?: string
}

type PagerProps = {
    previous: PagerItem
    next: PagerItem
}

export const Pager: FC<PagerProps> = ({ previous, next }): ReactNode => {
    return (
        <nav aria-label='Pagination' className='px-0 tab:px-[60px]'>
            <div className='border-y border-line'>
                <div className='fw-container flex min-h-[80px] items-center justify-between gap-6 py-5'>
                    <Link
                        href={previous.href}
                        className='group flex min-w-0 items-center gap-1.5 font-body text-[15px] leading-[1.4em] text-ink transition-colors duration-300 hover:text-white tab:text-[16px]'
                    >
                        <span
                            aria-hidden='true'
                            className='inline-block transition-transform duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:-translate-x-1'
                        >
                            ‹
                        </span>

                        <span className='truncate'>
                            {previous.label}
                        </span>

                        {previous.meta ? (
                            <span className='hidden shrink-0 text-ink-mute sm:inline'>
                                {previous.meta}
                            </span>
                        ) : null}
                    </Link>

                    <Link
                        href={next.href}
                        className='group flex min-w-0 items-center justify-end gap-1.5 text-right font-body text-[15px] leading-[1.4em] text-ink transition-colors duration-300 hover:text-white tab:text-[16px]'
                    >
                        {next.meta ? (
                            <span className='hidden shrink-0 text-ink-mute sm:inline'>
                                {next.meta}
                            </span>
                        ) : null}

                        <span className='truncate'>
                            {next.label}
                        </span>

                        <span
                            aria-hidden='true'
                            className='inline-block transition-transform duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:translate-x-1'
                        >
                            ›
                        </span>
                    </Link>
                </div>
            </div>
        </nav>
    )
}
